<template>
  <div style="width: 100%" :style="'height:' + (this.$store.state.windowHeight - 150) + 'px'" @click="handlePageClick">
    <el-space wrap>
      <el-input v-model="obj.searchValue" placeholder="个股 名称/代码" @input="handleInput" style="width: 250px" clearable>
        <template #prefix>
          <el-icon class="el-input__icon">
            <search />
          </el-icon>
        </template>
      </el-input>
      <el-select v-model="obj.selectedDayValue" @change="handleSelectDayChange" style="width:120px">
        <el-option v-for="item in obj.selectDayList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="handleRefresh">
        <el-icon class="el-input__icon">
          <refresh />
        </el-icon>
      </el-button>
    </el-space>
    <div class="pt-16">
      <el-space v-for="data in obj.symbolList" :key="data">
        <el-form-item label="">
          <el-input v-model="data.name" :disabled="true" style="width:80px;color:red" />
          <el-button type="danger" @click="del(data)">删除</el-button>
        </el-form-item>
      </el-space>
    </div>
    <el-table :data="obj.dataList" style="width: 100%" height="100%" :cell-style="cellStyle"
      :header-row-style="headerRowStyle" empty-text=" " @row-click="handleRowClick">
      <el-table-column width="110" fixed prop="name" label="" align="right" />
      <el-table-column width="110" align="right" v-for="(data, index) in obj.nameList" :key="index" :prop="data"
        :label="data" />
    </el-table>
    <div style="width: 250px; max-height: 420px;" class='search-ul'>
      <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
        {{ data['name'] }} {{ data['symbol'] }}
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { http } from '../util/http'
import { ElMessage } from 'element-plus'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const obj = reactive({
      searchValue: '',
      searchSymbol: '',
      symbolList: [],
      filteredList: [],
      nameList: [],
      dataList: [],
      selectDayList: [
        {
          value: '5',
          label: '最近 5日'
        },
        {
          value: '10',
          label: '最近 10日'
        },
        {
          value: '20',
          label: '最近 20日'
        },
        // {
        //   value: '30',
        //   label: '最近 30日'
        // },
        {
          value: '40',
          label: '最近 40日'
        },
        // {
        //   value: '50',
        //   label: '最近 50日'
        // },
        {
          value: '60',
          label: '最近 60日'
        },
        // {
        //   value: '120',
        //   label: '最近 120日'
        // },
      ],
      selectedDayValue: '5',
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '7')
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.correlationData === '') {
        // 无缓存，从后台请求数据
        renderSelect()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 获取数据渲染下拉框
    const renderSelect = () => {
      let formData = new FormData()
      formData.append("category", "all")
      formData.append("page", 1)
      formData.append("limit", "10000")
      http({
        url: `/market`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data.data)
        obj.searchList = res.data.data.data
      })
    }

    // 搜索框输入事件
    const handleInput = () => {
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
        item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索结果点击事件
    const handleClick = (data) => {
      obj.searchValue = ''
      obj.filteredList = []

      let msg = ''
      obj.symbolList.forEach((item) => {
        if (item.name === data['name']) {
          msg = '已经被选过了'
        }
        if (obj.symbolList.length === 10) {
          msg = '最多选择10个'
        }
      })

      if (msg !== '') {
        ElMessage.error(msg)
        obj.searchValue = ''
        return
      }

      obj.symbolList.push(data)
    }

    // 删除品种
    const del = (data) => {
      obj.symbolList.forEach((item) => {
        if (item.name === data.name) {
          // console.log(item.name)
          obj.symbolList.splice(obj.symbolList.indexOf(item), 1)
        }
      })
      // 清空数据，重新请求
      obj.nameList = []
      obj.dataList = []
      requestData()
    }

    // 后台获取数据
    const requestData = () => {
      let formData = new FormData()
      var symbolList = []
      obj.symbolList.forEach((item) => {
        symbolList.push(item.symbol)
      })

      if (symbolList.length < 2) {
        ElMessage.error("至少需要选择2个品种")
        return
      }

      // console.log(symbolList.join(","))
      formData.append("symbols", symbolList.join(","))
      formData.append("range", obj.selectedDayValue)
      http({
        url: `/correlation`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res)
        processData(res)
        setStore()
      })
    }

    // 加工处理数据
    const processData = (res) => {
      // 对应golang map接受顺序打乱问题, 使用后台返回的res.data.sort做为表头数据
      var tempList = []
      if (res.data.sort.length !== 0) {
        for (var key of res.data.sort) {
          tempList.push(key) // 设置表头数据
        }
      }
      for (var i in res.data.data) {
        for (var k in res.data.data[i]) {
          res.data.data[i][k] = res.data.data[i][k].toFixed(2) // 保留2位小数
        }
        res.data.data[i].name = tempList[i] // 增加第一列
      }
      obj.nameList = tempList
      obj.dataList = res.data.data
    }

    // 保存至store
    const setStore = () => {
      var storeObj = {
        'searchList': obj.searchList,
        'filteredList': obj.filteredList,
        'searchValue': obj.searchValue,
        'searchSymbol': obj.searchSymbol,
        'symbolList': obj.symbolList,
        'nameList': obj.nameList,
        'dataList': obj.dataList,
        'selectedDayValue': obj.selectedDayValue
      }
      store.commit('setCorrelationData', storeObj) // 缓存数据
    }

    // 获取Store
    const getStore = () => {
      obj.searchList = store.state.correlationData.searchList
      obj.filteredList = store.state.correlationData.filteredList
      obj.searchValue = store.state.correlationData.searchValue
      obj.searchSymbol = store.state.correlationData.searchSymbol
      obj.symbolList = store.state.correlationData.symbolList
      obj.nameList = store.state.correlationData.nameList
      obj.dataList = store.state.correlationData.dataList
      obj.selectedDayValue = store.state.correlationData.selectedDayValue
    }

    // 下拉框选择事件
    const handleSelectDayChange = (value) => {
      requestData()
    }

    // 按钮刷新事件
    const handleRefresh = (e) => {
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      console.log(row)
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 页面空白点击事件
    const handlePageClick = () => {
      obj.filteredList = []
      obj.searchValue = ''
    }

    // 设置表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      for (var i in obj.nameList) {
        if (parseFloat(row.row[obj.nameList[i]]) === 0 && row.columnIndex === parseFloat(i) + 1) {
          return { color: 'black' }
        } else if (parseFloat(row.row[obj.nameList[i]]) === 1 && row.columnIndex === parseFloat(i) + 1) {
          return { color: 'black' }
        } else if (parseFloat(row.row[obj.nameList[i]]) > 0 && row.columnIndex === parseFloat(i) + 1) {
          return { color: 'red' }
        } else if (parseFloat(row.row[obj.nameList[i]]) < 0 && row.columnIndex === parseFloat(i) + 1) {
          return { color: 'green' }
        }
      }
    }

    // 设置表格头部样式
    const headerRowStyle = (row, column, rowIndex, columnIndex) => {
      return 'font-size:14px; color:#606266'
    }

    return {
      obj,
      store,
      handleInput,
      handleClick,
      del,
      handleSelectDayChange,
      handleRefresh,
      handleRowClick,
      handlePageClick,
      cellStyle,
      headerRowStyle,
    }
  }
}
</script>
<style lang="scss" scoped>
/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 80px;
  top: 100px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}

.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.search-ul2 {
  position: absolute;
  left: 550px;
  top: 100px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}

.search-li2 {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.search-li2:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
